import React from "react";
import { Label } from "@/components/ui/label";

export const AREA_PRESETS = [
  { key: "city_only", label: "City only", hint: "Municipal boundary — tightest search", padding: "0% padding" },
  { key: "city_plus_suburbs", label: "City + close suburbs", hint: "Recommended — includes bordering communities", padding: "+15% padding" },
  { key: "wide_metro", label: "Wide metro", hint: "Covers surrounding towns 25-40km out", padding: "+40% padding" },
];

export default function AreaPresetPicker({ value, onChange }) {
  return (
    <div>
      <Label className="text-xs uppercase tracking-wide text-slate-600 block mb-2">Search area</Label>
      <div className="grid grid-cols-3 gap-1.5" role="radiogroup" aria-label="Search area preset">
        {AREA_PRESETS.map((preset) => {
          const active = preset.key === value;
          return (
            <button
              key={preset.key}
              type="button"
              onClick={() => onChange(preset.key)}
              role="radio"
              aria-checked={active}
              data-testid={`scan-expansion-${preset.key}`}
              className={
                "text-left rounded-md border px-3 py-2 min-h-[68px] transition-colors " +
                (active ? "border-rose-600 bg-rose-50 shadow-inner" : "border-slate-200 hover:border-slate-300")
              }
            >
              <div className={"text-xs font-semibold " + (active ? "text-rose-800" : "text-slate-800")}>{preset.label}</div>
              <div className="text-[10px] text-slate-500 mt-0.5 leading-tight">{preset.hint}</div>
              <div className={"text-[10px] font-mono mt-1 " + (active ? "text-rose-500" : "text-slate-400")}>{preset.padding}</div>
            </button>
          );
        })}
      </div>
    </div>
  );
}
